import React from "react";
import {
  comGeradorDePeriodo,
  getDataBaseSelecionadaAsString,
  getEdicaoMedida,
} from "../../../state";
import SelecaoPeriodoTrimestres from "../configuracoes/periodos/SelecaoPeriodoTrimestres";

export const processarSelecaoTrimestres = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);

    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      dataBase: dataBase,
      ajusteDias: edicaoMedida.ajusteDias,
    }));
  }
);

export default function SelecaoTrimestres() {
  return <SelecaoPeriodoTrimestres />;
}
